import { useNavigate } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";

const AuthLoadingScreen = ({ message = "Restoring your secure session...", error }) => (
  <Screen message={message} error={error} />
);

const Screen = ({ message, error }) => {
  const { logout } = useStateContext();
  const navigate = useNavigate();

  return (
    <main className="min-vh-100 d-flex align-items-center justify-content-center p-4">
      <div className="text-center" role={error ? "alert" : "status"} aria-live="polite">
        {error ? (
          <>
            <h1 className="h5">Tenant access could not be verified</h1>
            <p className="text-secondary">{error}</p>
            <button type="button" className="btn btn-dark" onClick={() => { logout(); navigate("/", { replace: true }); }}>
              Sign out
            </button>
          </>
        ) : (
          <>
            <div className="spinner-border text-primary mb-3" aria-hidden="true" />
            <p className="text-secondary mb-0">{message}</p>
          </>
        )}
      </div>
    </main>
  );
};

export default AuthLoadingScreen;